<template>
  <div id="resetPassword" class="row justify-content-md-center">
    <div v-if="$route.query.resetKey && $route.query.resetKey !=''" class="col-12 col-md-6 col-xl-4">
        <h1>Reset Password</h1>
        <!-- TODO: CMS wording forgotten password -->
        <h2></h2>

        <form class="forgottenPassword row" v-on:submit.prevent="submitResetPassword">

          <label class="col-12 col-sm-4">New Password</label>
          <input
            v-model="password"
            type="password"
            name="Password"
            v-validate="'required|min:8'"
            autocomplete="new-password"
            ref="password"
            class="col-12 col-sm-8 form-control"
          >
          <div class="invalid-feedback">{{errors.first('Password')}}</div>

          <label class="col-12 col-sm-4">Confirm New Password</label>
          <input
            v-model="confirm_password"
            type="password"
            name="Confirm Password"
            v-validate="'required|confirmed:password'"
            autocomplete="new-password"
            class="col-12 col-sm-8 form-control"
            v-on:keyup.enter="submitResetPassword"
          >
          <div class="invalid-feedback">{{errors.first('Confirm Password')}}</div>

          <ButtonWithLoading
            type="submit"
            :state="submitState"
            text="Reset"
            loadingText="Resetting Password"
            successText="Password has been reset"
            failureText="Error resetting password"
          ></ButtonWithLoading>

          <div v-if="message" class="alert alert-warning">
            {{message}}
          </div>
        </form>
      </div>
      <div v-else>
        Couldn't reset password with that link. Try copying it from your email instead.
      </div>
      <vue-headful
          title="Reset Password | Cherrytree"
      />
  </div>
</template>

<script>
import ButtonWithLoading from "@/components/buttonWithLoading";

import { resetPassword } from "@/network/userRequests";

export default {
  name: "ResetPassword",
  components: {
    ButtonWithLoading
  },
  data() {
    return {
      password: null,
      confirm_password: null,
      submitState: null,
      message: null
    };
  },
  methods: {
    passwordErrorHandler(){
      this.submitState="failure"
      // TODO string for password reset failure
      this.message = "Error resetting password, maybe the link expired, try requesting another password reset email."
    },
    submitResetPassword() {
      this.$validator.validateAll().then(valid => {
        if (!valid) return;
        this.submitState = "loading";

        const { password } = this;
        const resetKey = this.$route.query.resetKey;

        resetPassword({password: password, resetKey: resetKey}, result =>{
          if(result.success){
            this.submitState="success"
            setTimeout(()=>{
                this.$router.push({name: 'login'})
            }, 700)
          }else{
            this.passwordErrorHandler()
          }
        },this.passwordErrorHandler)
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
